import type { SemanticColor } from '@atlaskit/lozenge';

export const SPF_ASK_STATUS_CONFIG: Record<string, { display: string; appearance: SemanticColor }> =
	{
		ACCEPTED: { display: 'Accepted', appearance: 'success' },
		CANCELED: { display: 'Canceled', appearance: 'neutral' },
		DEFERRED: { display: 'Deferred', appearance: 'danger' },
		DRAFT: { display: 'Draft', appearance: 'neutral' },
		IN_REVIEW: { display: 'In Review', appearance: 'information' },
		REVISING: { display: 'Revising', appearance: 'information' },
		SUBMITTED: { display: 'Submitted', appearance: 'information' },
	};

export const getAskStatusAppearance = (status?: string): SemanticColor => {
	return SPF_ASK_STATUS_CONFIG[status ?? '']?.appearance ?? 'neutral';
};

export const formatSpfAskStatus = (status?: string): string | undefined => {
	return status ? SPF_ASK_STATUS_CONFIG[status]?.display : undefined;
};
